import {createContext} from "react";

const MSidebarContext = createContext();

export default MSidebarContext;